import React from "react";
import Dashboard from "./pages/Dashboard";
import "./App.css";

export default function App() {
  return <Dashboard />;
}
